/*
 * 验证码sdk
 */
import React, { useEffect, forwardRef, useImperativeHandle, useRef, useState } from 'react'
import { message } from 'antd'
import { Deferred, getUniqueId, getSystemLocale } from '@/utils'
import { LOCAL_ENUM } from '@/constants'
import { useTranslation } from '@/libs/next-lang'
interface Props {
  lang?: 'zh-cn' | 'en'
}

// let elementIdIndex = 0
// const genElementId = () => {
//   return (elementIdIndex += 1)
// }

const Captcha = forwardRef((props: Props, ref) => {
  const { lang } = props
  const captchaInsRef: any = useRef<any>(null)
  const elementId = useRef(`captcha-${getUniqueId()}`)
  const defRef: any = useRef<any>(null)
  const [open, setOpen] = useState(false)

  const { t } = useTranslation(['components'])

  useImperativeHandle(ref, () => ({
    verify: async () => {
      if (!captchaInsRef.current) {
        return message.error(t('components:t16'))
      }
      defRef.current = new Deferred()
      captchaInsRef.current?.verify()
      return defRef.current.promise
    },
    refresh: () => {
      captchaInsRef.current?.refresh()
    },
    open,
  }))

  const getLocale = (v: string) => {
    if (v && v === 'en') {
      return 'en'
    }
    const locale = getSystemLocale();
    return locale === LOCAL_ENUM.EN_US ? 'en' : LOCAL_ENUM.ZH_CN
  }

  useEffect(() => {
    if (elementId.current) {
      const language = getLocale(lang)
      // @ts-ignore
      // 文档 https://support.dun.163.com/documents/15588062143475712?docId=294963751458885632#%E5%8F%82%E6%95%B0%E8%AF%A6%E6%83%85
      const initNECaptchaWithFallback = window.initNECaptchaWithFallback
      initNECaptchaWithFallback(
        {
          element: `#${elementId.current}`,
          captchaId: '312e5ea3f8cc4674b490830ad4fb817b',
          width: '320px',
          mode: 'popup',
          apiVersion: 2,
          popupStyles: {
            position: 'fixed',
            top: '20%',
          },
          lang: language,
          onOpen() {
            setOpen(true)
          },
          onVerify(err: any, data: any) {
            /**
             * 第一个参数是err（Error的实例），验证失败才有err对象
             * 第二个参数是data对象，验证成功后的相关信息，data数据结构为key-value，如下：
             * {
             *   validate: 'xxxxx' // 二次验证信息
             * }
             **/
            if (err) {
              // 当验证失败时，内部会自动refresh方法，无需手动再调用一次
              // defRef.current.reject(err)
              return
            }
            defRef.current?.resolve(data)
          },
          onClose() {
            setOpen(false)
            defRef.current?.reject({ open: false })
            captchaInsRef.current?.refresh()
          },
        },
        function onload(instance: any) {
          captchaInsRef.current = instance
        },
        function onerror(err: any) {
          console.error('验证码sdk初始化失败: ', err)
          message.error(t('components:t16'))
        },
      )
    } else {
      message.error(t('components:t16'))
    }
  }, [])

  return <div id={elementId.current} />
})

export default Captcha
